export default "__VITE_ASSET__z4$m6lrt__"